<template>
  <div id="school">
    <div class="head glRowCenter">
      <img :src="MyImage.school.logo" alt="" />
      <div class="hk">HKUST(GZ)</div>
      <div class="glFlex"></div>
      <div v-for="(it, i) in tab" @click="() => clkTab(i)" class="it" :class="i == 0 ? 'itOn' : ''" :key="it.lab">{{
        it.lab }}</div>
    </div>

    <router-view class="glCon glScroll" />

    <div class="bt">© Untitled. All rights reserved.</div>
  </div>
</template>

<script setup lang="ts">
import { MyImage } from "@icon/MyImage";

const tab = [
  { lab: "About" },
  { lab: "Research" },
  { lab: "Publications" },
  { lab: "People" },
  // { lab: "Contact" },
];

const clkTab = (i = 0) => {
  const tmp: any = {
    '0': 'about',
    '1': 'Research',
    '2': 'Publications',
    '3': 'People',
  }
  document.getElementById(tmp[i.toString()])?.scrollIntoView()
}
</script>

<style scoped>
#school {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.head {
  display: flex;
  align-items: center;
  height: var(--dimHeader);
  border-bottom: 1px solid #0000000d;
  padding: 0 var(--dimCon);
}

.hk {
  margin-left: 18px;
  font-size: 20px;
}

.it {
  font-size: 16px;
  margin: 0 1rem;
  height: var(--dimHeader);
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.it:last-child {
  margin-right: 0;
}

.itOn {
  background-color: var(--colorApp);
  color: white;
}

.bt {
  text-align: center;
  margin-bottom: 46px;
  font-size: 16px;
}
</style>
